import { Breadcrumbs } from "../../components";
import { getFullPath, routes } from "../../routes";
import { Link } from "react-router-dom";
import { ScopeOfWork } from "@/api/williams/scopesOfWork";
import { String } from "@/util";

export function SOWFormBreadcrumbs({ data }: { data: Readonly<ScopeOfWork> }) {
  return (
    <>
      {data.project?.number && (
        <Breadcrumbs>
          <Link className="link-primary" to={getFullPath(routes.project.list)}>
            Projects
          </Link>
          <Link className="link-primary" to={getFullPath(routes.project.open(data.project.id))}>
            {String.truncate(data.project?.number, 15)}
          </Link>
          <Link className="link-primary" to={window.location.href} state={data}>
            {data.number}
          </Link>
        </Breadcrumbs>
      )}
    </>
  );
}
